export default __webpack_public_path__ + "static/media/lg-c.2862a413.jpg";